import { Typography } from '@material-ui/core'
import { useTranslate } from 'react-admin'
import {
  darkGrey,
  isActionRequired,
  isLastStep,
  requiredActionDescription,
} from '../utils'

const CtaDescription = ({ record }) => {
  const translate = useTranslate()
  if (isLastStep(record) === true) return null
  if (isActionRequired(record.state_transition) === false) {
    return null
  }

  return (
    <div style={{ width: '100%' }}>
      <Typography
        variant="h5"
        style={{
          color: darkGrey,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
      >
        <p style={{ margin: 0 }}>{record.state_transition.description}</p>
      </Typography>
    </div>
  )
}
export default CtaDescription
